var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{staticClass:"font-weight-bolder text-primary",style:(_vm.mentorshipTypeColor),attrs:{"id":"mentorship-type"}},[_vm._v(" "+_vm._s(_vm.mentorshipType ? _vm.$t(_vm.mentorshipType) : '')+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }